// Height reserved for navbar + page title + the panel's own padding, so the cart
// panel grows with the window instead of being pinned to a fixed viewport fraction.
const CHROME_OFFSET = '220px';

export const moveCartPanelStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: `calc(100vh - ${CHROME_OFFSET})`,
    minHeight: '45vh'
};

export const moveCartScrollStyle = {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto'
};

export const moveCartActionsStyle = {
    textAlign: 'right',
    alignSelf: 'self-end',
    paddingTop: '.5rem'
};
